import type { CampaignSuffix } from '~clientState/hooks/useCampaignSuffix/useCampaignSuffix';

const getHeaderBackgroundStyle = (campaignSufix: CampaignSuffix) => {
  if (campaignSufix === 'C') {
    return { backgroundColor: 'secondary.50' };
  }
  return {
    background: 'linear-gradient(314.19deg, #F9700C 0%, #DA3835 100%)',
  };
};

export default getHeaderBackgroundStyle;
